export default {
  menu: {
    dashboard: "Dashborad",
    orderManage: "OrderManage",
    originalOrders: "OriginalOrders",
    omsOrders: "OMSOrders",
    originalAfterSales: "OriginalAfterSales",
    omsAfterSales: "OMSAfterSales",
    batchModifyOrder: "BatchModifyOrder",
    returnToStorage: "ReturnToStorage",
    orderEntry: "OrderEntry"
  }
};
